import Components from './components/components';

Vue.use(Components);

require('./app');



// WEBPACK FOOTER //
// ./resources/assets/js/common.js